import type { WorkbenchPanelContribution } from '@crowdex/plugin-contracts';
import { PROJECT_PANELS } from '@/features/assistants/assistant-views';

/** Who owns the core's own panels in the workbench (never an installed plugin). */
export const CORE_PANEL_OWNER = 'crowdex';

/** The view of the core's team panel, shown with a team's conversation. */

/** The view of the core's Live panel: the call with the user's assistant. */
export const CORE_LIVE_VIEW = `plugin:${CORE_PANEL_OWNER}/live` as const;

/** The view of the core's terminal panel. */
export const CORE_TERMINAL_VIEW = `plugin:${CORE_PANEL_OWNER}/terminal` as const;

/** Opens a new browser tab, as in a browser (⌘T, Ctrl+T). */
const NEW_BROWSER_TAB = { key: 't', commandOrControl: true } as const;

/** The panels the core shows without any plugin. Plugins cannot provide these surfaces. */
export const CORE_PANELS: readonly WorkbenchPanelContribution[] = [
  {
    id: 'browser',
    title: 'Browser',
    description: 'A web page the agent can see',
    summaryLabel: 'Browser tabs',
    icon: 'globe',
    hostView: 'web-surface',
    // A tool of the conversation, offered with the apps: it docks beside the conversation.
    rail: {},
    session: {
      surface: 'web',
      multiple: true,
      shortcut: NEW_BROWSER_TAB,
      newInstanceLabel: 'New browser tab',
      mentionKind: 'tab',
      mentionDetail: 'Browser tab',
    },
  },
  {
    id: 'live',
    title: 'Live',
    description: 'Talk with your assistant, who keeps track of all your conversations',
    icon: 'audio-lines',
    hostView: 'live',
    // The call, offered with the apps: it docks beside the conversation on screen.
    rail: {},
  },
  {
    id: 'terminal',
    title: 'Terminal',
    description: 'A shell in the conversation’s Dossier',
    summaryLabel: 'Terminals',
    icon: 'terminal',
    hostView: 'terminal-surface',
    session: {
      surface: 'terminal',
      multiple: true,
      newInstanceLabel: 'New terminal',
      mentionKind: 'terminal',
      mentionDetail: 'Terminal',
    },
  },
  // A project conversation's tabs: opened by it, never offered elsewhere.
  ...PROJECT_PANELS,
];
